module.exports = __webpack_public_path__ + "components/flag/static/square/mn-e563bb38abecad4733f04279a2a0770c.svg";